import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMergeConfig = {
  extend: {
    theme: {
      text: [
        (str: string) =>
          /display|heading|body|button|btn|numbers|menu|caption|legend|overline|inline|label/.test(
            str,
          ),
      ],
    },
  },
};

const twMerge = extendTailwindMerge(twMergeConfig);

const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export { cn, twMergeConfig };
